"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentInjectionManager = void 0;
var preact_1 = require("preact");
var kaltura_player_js_1 = require("@playkit-js/kaltura-player-js");
var models_1 = require("./models");
var ui_1 = require("./ui");
var ReservedPresetNames = kaltura_player_js_1.ui.ReservedPresetNames;
var ComponentInjectionManager = /** @class */ (function () {
    function ComponentInjectionManager(options) {
        this._currentComponent = null;
        this._kalturaPlayer = options.kalturaPlayer;
        this._logger = options.logger;
    }
    ComponentInjectionManager.prototype.inject = function (options) {
        // Validate component is a function for security
        if (typeof options.component !== 'function') {
            this._logger.error('Component must be a function');
            return;
        }
        // Remove existing component if any
        if (this._currentComponent) {
            this._removeCurrentComponent();
        }
        // Render and store removal function
        var removeFunction = this._renderComponent(options);
        if (!removeFunction) {
            this._logger.error('Failed to inject component');
            return;
        }
        this._currentComponent = {
            component: options.component,
            props: options.props,
            position: options.position,
            removeFunction: removeFunction
        };
    };
    ComponentInjectionManager.prototype.remove = function () {
        this._removeCurrentComponent();
        this._currentComponent = null;
    };
    ComponentInjectionManager.prototype.getCurrentPosition = function () {
        var _a;
        return ((_a = this._currentComponent) === null || _a === void 0 ? void 0 : _a.position) || null;
    };
    ComponentInjectionManager.prototype.reset = function () {
        this.remove();
    };
    ComponentInjectionManager.prototype._removeCurrentComponent = function () {
        if (!this._currentComponent) {
            return;
        }
        // Call removal function (SideBySideWrapper's cleanup will restore video)
        this._currentComponent.removeFunction();
    };
    ComponentInjectionManager.prototype._renderComponent = function (options) {
        var _this = this;
        var position = options.position, component = options.component, props = options.props;
        // Handle all corner positions
        if (position === models_1.InjectionPosition.TopLeft ||
            position === models_1.InjectionPosition.TopRight ||
            position === models_1.InjectionPosition.BottomLeft ||
            position === models_1.InjectionPosition.BottomRight) {
            return this._kalturaPlayer.ui.addComponent({
                label: "component-injection-".concat(position),
                presets: [ReservedPresetNames.Playback, ReservedPresetNames.Live],
                container: 'VideoArea',
                get: function () { return (0, preact_1.h)(ui_1.CornerOverlay, { position: position }, component(props)); }
            });
        }
        else if (position === models_1.InjectionPosition.SideBySide) {
            return this._kalturaPlayer.ui.addComponent({
                label: 'component-injection-side-by-side',
                presets: [ReservedPresetNames.Playback, ReservedPresetNames.Live],
                container: 'PlayerArea',
                get: function () { return ((0, preact_1.h)(ui_1.SideBySideWrapper, { player: _this._kalturaPlayer, component: component, componentProps: props, replaceVideoWithImageUrl: options.replaceVideoWithImageUrl })); }
            });
        }
        this._logger.error("Unsupported injection position: ".concat(position));
        return null;
    };
    return ComponentInjectionManager;
}());
exports.ComponentInjectionManager = ComponentInjectionManager;
